module.exports = __webpack_public_path__ + "img/photo-studio-lighting.a035702b.png";